import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { STATUS_OBJECT } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { PrintService } from 'src/app/services/print.service';
import { BOOK_STORE_TABS } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { EnrollmentStore } from 'src/app/stores/enrollment/enrollment.store';
import { MatDialog } from '@angular/material';
import { AddClassroomComponent } from './add-classroom/add-classroom.component';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-classroom',
  templateUrl: './classroom.component.html',
  styleUrls: ['./classroom.component.scss']
})
export class ClassroomComponent implements OnInit {

  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs = BOOK_STORE_TABS.CLASSROOMS;
  DISPLAY_STATUS_KEY: any;

  constructor(
    private dialog:MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    public store: EnrollmentStore,
    public ps: PrintService,
    private api: ApiService
  ) { }

   ngOnInit() {
    this.store.fetchClass();

    // this.api.get(`${this.api.baseUri}fetchAcademicTerm`).then((res) => {
    // }).catch(error => {
    //   alert(error)
    // })

  }
  
  create(item: any) {
    let dialogRef = this.dialog.open(AddClassroomComponent, {
      data: {
        ITEM: item,
      },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {});
  }

  // create() {
  //   this.router.navigate([`/enrollment/classrooms/admission/draft`])
  // }
  
  edit(item:any) {
    this.router.navigate([`/enrollment/classrooms/admission/${item.key}`])
  }
}

